import React from 'react';
import './css/Location.css';

const Location: React.FC = () => {
    return (
        <div className="location-page">
            <div className="loc-main-content">
                <div className="loc-content-container">
                    <div className="loc-info-section">
                        <div className="loc-section-header">
                            <h2>Холбоо Барих Мэдээлэл</h2>
                        </div>
                        <div className="loc-info-container">
                            <div className="loc-contact-row">
                                <div className="loc-contact-info loc-card-style">
                                    <div className="loc-contact-icon-container">
                                        <div className="loc-contact-icon">📍</div>
                                    </div>
                                    <div className="loc-contact-text">
                                        <h3>Хаяг байршил</h3>
                                        <p className="loc-hover-effect">Эрдэнэт хот, Баян-Өндөр сум, Говил багт байрлах хуучин эсгий гутлын үйлдвэрийн байр.</p>
                                    </div>
                                </div>
                                <div className="loc-contact-info loc-card-style">
                                    <div className="loc-contact-icon-container">
                                        <div className="loc-contact-icon">📍</div>
                                    </div>
                                    <div className="loc-contact-text">
                                        <h3>Манай Оффис</h3>
                                        <p className="loc-hover-effect">Амгалан оршихуйн ордон 1 давхар 105 тоот</p>
                                    </div>
                                </div>
                            </div>

                            <div className="loc-contact-row">
                                <div className="loc-contact-info loc-card-style">
                                    <div className="loc-contact-icon-container">
                                        <div className="loc-contact-icon">📞</div>
                                    </div>
                                    <div className="loc-contact-text">
                                        <h3>Холбогдох утас</h3>
                                        <p className="loc-hover-effect">(+976) 7707-1771</p>
                                        <p className="loc-hover-effect">(+976) 9911-6810</p>
                                        <p className="loc-hover-effect">(+976) 9920-2137</p>
                                        <p className="loc-hover-effect">(+976) 8850-5738</p>
                                    </div>
                                </div>

                                <div className="loc-contact-info loc-card-style">
                                    <div className="loc-contact-icon-container">
                                        <div className="loc-contact-icon">✉️</div>
                                    </div>
                                    <div className="loc-contact-text">
                                        <h3>Имэйл хаяг</h3>
                                        <p className="loc-hover-effect">info@erdenetcars.mn</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="loc-map-section">
                        <div className="loc-section-header">
                            <h2>Бидний Байршил</h2>
                        </div>
                        <div className="loc-map-container">
                            <iframe
                                className="location-map"
                                src="https://maps.google.com/maps?q=49.058733,104.127512&z=15&t=k&output=embed"
                                loading="lazy"
                                allowFullScreen
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Google Map Satellite View with Marker"
                            />
                        </div>
                    </div>
                </div>
            </div>


        </div >
    );
};

export default Location;